// extracted by mini-css-extract-plugin
export default {"culturePointer":"CulturePointer_culturePointer__APR8K","text1":"CulturePointer_text1__D808C","text2":"CulturePointer_text2__wCvRj"};